import { Options } from "react-markdown";

import { FormattedMessage } from "react-intl";
import UserMarkdown from "../UserMarkdown";

export interface Props {
  value?: string | null;
  markdown?: (options: Options) => JSX.Element;
}

export function Preview({ value, markdown = UserMarkdown }: Props) {
  return (
    <>
      {!value?.trimStart() || value === undefined ? (
        <p className="text-gray-400 italic">
          <FormattedMessage defaultMessage="Nothing to preview" />
        </p>
      ) : (
        markdown({ children: value })
      )}
    </>
  );
}
